import { render, staticRenderFns } from "./DnsRecordList.vue?vue&type=template&id=380ed08a&scoped=true&"
import script from "./DnsRecordList.vue?vue&type=script&lang=js&"
export * from "./DnsRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380ed08a",
  null
  
)

export default component.exports